export const CSRF_URL = '/sanctum/csrf-cookie';
export const AUTH_URL = '/auth';
export const STORE_URL = '/store';
export const PRODUCT_URL = '/product';
export const ORDER_URL = '/order';
export const CART_URL = '/cart';
export const STORE_SHOPPER_URL = '/store_shopper';
export const VERIFY_URL = '/verify';
export const DELIVERY_ADDRESS_URL = '/delivery_address';
export const SEARCH_URL = '/search';
export const USER_URL = '/user';
export const COMPANY_URL = '/company';
export const CLIENT_URL = '/client';
export const MERCHANT_CATEGORY_CODE_URL = '/merchant_category_code';
export const TRANSACTION_URL = '/transaction';
export const REFUND_URL = '/refund';
export const PAYOUT_URL = '/payouts';
export const WEBHOOK_URL = '/webhook';
export const TRANSFER_URL = '/transfer';
export const DISPUTE_URL = '/dispute';
export const ACTION_URL = '/action';
export const FEE_STRUCTURE_URL = '/fee_structure';
